import React, { useContext, useReducer } from "react";
import gsap from "gsap";
import Reducer from "../reducer/Reducer";

const initialState = {
  isSidebarOpen: false,
};

const ProductsContext = React.createContext();

const ProductsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);

  const openSidebar = () => {
    dispatch({ type: "SIDEBAR_OPEN" });
  };

  const CursorBig = () => {
    gsap.to(".cursor", { scale: 5 });
  };
  const CursorSmall = () => {
    gsap.to(".cursor", { scale: 1 });
  };

  const showCurText = (text) => {
    const curText = document.querySelector(".curText");
    gsap.to(".curText", { opacity: 1, visibility: "visible" });
    curText.innerHTML = text;
  };

  const hideCurText = () => {
    gsap.to(".curText", { opacity: 0, visibility: "hidden" });
    const curText = document.querySelector(".curText");
    curText.innerHTML = "";
  };

  return (
    <ProductsContext.Provider
      value={{
        ...state,
        openSidebar,
        CursorBig,
        CursorSmall,
        showCurText,
        hideCurText,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
// make sure use
const useProductsContext = () => {
  return useContext(ProductsContext);
};

export { ProductsProvider, useProductsContext };
